import styled from 'styled-components';
import { getCombinedClassNames } from 'utils/style';

const NewsletterInput = styled.input.attrs(() => {
  const classNameToAdd = ['rounded-full', 'px-4', 'py-2', 'text-basic-500', 'font-bold', 'focus:outline-none'];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})`
  width: calc(100% - 0.25rem);
  &::placeholder {
    font-weight: 400;
  }
`;

const NewsletterSubmitBtn = styled.button.attrs(() => {
  const classNameToAdd = [
    'p-4',
    'bg-primary',
    'rounded-full',
    '-ml-10',
    'transition-shadow',
    'duration-150',
    'ease-out',
    'focus:outline-none',
    'hover:shadow-primary',
    'active:bg-primary-600',
  ];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const Notification = styled.div.attrs(({ type }) => {
  const typeClass = type === 'error' ? 'border-notification-error' : 'border-notification-success';
  const classNameToAdd = ['px-2', 'py-4', 'border-t-2', 'bg-white', 'text-basic-700', typeClass];
  return {
    className: getCombinedClassNames(classNameToAdd),
  };
})``;

const NotificationArrow = styled.div`
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;

  border-bottom: 10px solid white;
  margin-top: -1.5rem;
  margin-bottom: 0.5rem;
`;

// eslint-disable-next-line import/prefer-default-export
export { NewsletterInput, NewsletterSubmitBtn, NotificationArrow, Notification };
